import GameDeleteConfirmPopup from "./GameDeleteConfirmPopup";

export default GameDeleteConfirmPopup;